import { useTasksController_completeTask } from '@/services/hooks';
import type { CompleteTaskDto } from '@/services/types';

import { ignoreBody, useMappedMutation } from '../shared/mutation';

import type { CompleteTaskVariables, UseCompleteTaskResult } from './types';

function completeTaskToApi(variables: CompleteTaskVariables) {
    const requestBody: CompleteTaskDto = { comment: variables.comment };
    return { taskId: variables.taskId, requestBody };
}

export const useCompleteTask = (): UseCompleteTaskResult =>
    useMappedMutation(useTasksController_completeTask(), completeTaskToApi, ignoreBody);
